import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
interface UnidadeOrganica {
  id: string;
  nome: string;
  sigla: string;
}
@Injectable({
  providedIn: 'root'
})
export class UnidadeOrganicaService {
  private readonly path = 'bolsa';
  public params = new HttpParams();

  constructor(private apiService: ApiService) {}

  // List all Unidade Organica
  list(params?: any): Observable<any> {
    return this.apiService.get<{ data: UnidadeOrganica[] }>(`${this.path}/getAllUnidadeOrganica`, params ? new HttpParams({
      fromObject: params
    }) : this.params).pipe(
      map(response => response)
    );
  }

  // Get Unidade Organica by ID
  public show(id: string): Observable<any> {
    return this.apiService.get<{ object: UnidadeOrganica }>(`${this.path}/getUnidadeOrganicaById/${id}`).pipe(
      map(response => response)
    );
  }

  // Create new Unidade Organica
  public store(unidadeOrganica: UnidadeOrganica): Observable<any> {
    return this.apiService
      .post<{ object: UnidadeOrganica }>(`${this.path}/AddUnidadeOrganica`, unidadeOrganica)
      .pipe(
        map((response) => response)
      );
  }

  // Update existing Unidade Organica
  public update(unidadeOrganica: UnidadeOrganica): Observable<any> {
    return this.apiService
      .put<{ object: UnidadeOrganica }>(`${this.path}/UpdateUnidadeOrganica`, unidadeOrganica)
      .pipe(
        map((response) => response)
      );
  }

  // Delete existing Unidade Organica
  public delete(id: string): Observable<any> {
    return this.apiService.delete(`${this.path}/DeleteUnidadeOrganicaById/${id}`);
  }
}
